import React from 'react';
import PropTypes from 'prop-types';

function PlanIdNetwork({ medicarePlanInfo, zipCode }) {
  const refactoredInformation = medicarePlanInfo.hits.hits[0]._source;

  return (
    <div
      className="tab-pane fade"
      id="pills-network-medicare"
      role="tabpanel"
      aria-labelledby="pills-medicare-network-tab"
      tabIndex={0}
    >
      <div>
        <h1 className="drug-name">Plan &amp; Network</h1>
        <div className="row">
          <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
            <label>Plan Name</label>
            <p>{refactoredInformation.PLAN_NAME}</p>
          </div>
          <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
            <label>Issuer Name</label>
            <p>{`${refactoredInformation.Organization_Marketing_Name} - ${refactoredInformation.CONTRACT_NAME}`}</p>
          </div>
          <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
            <label>ZIP Code - State</label>
            <p>{`${zipCode} - ${refactoredInformation.STATE}`}</p>
          </div>
          <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
            <label>Contract ID</label>
            <p>{refactoredInformation.CONTRACT_ID}</p>
          </div>
          <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
            <label>Formulary ID</label>
            <p>{refactoredInformation.FORMULARY_ID}</p>
          </div>
          <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
            <label>Special Needs Plan</label>
            <p>{refactoredInformation.SNP ? 'Yes' : 'No'}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

PlanIdNetwork.propTypes = {
  medicarePlanInfo: PropTypes.object.isRequired,
  zipCode: PropTypes.string.isRequired,
};
export default PlanIdNetwork;
